/* LocationCard.tsx generated by @compiled/babel-plugin v0.38.1 */
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./LocationCard.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { IconButton, LinkButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/core/copy';
import Image from '@atlaskit/image';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { onAIAnswerCopyButtonClicked, onAIAnswerTabClick, onNonGenerativeAIAnswerResultShown } from '../../../ai-answer-dialog/analytics';
import { SainAction, useAnalytics, useSAINUsageCriteriaMet } from '../../../common/controller/analytics';
import { getSAINLayerFrontendMutiArmExperiment } from '../../../common/utils/get-sain-layer-frontend-experiment';
import { AIAnswerTab, aiAnswerTabsOrder, AnswerCardType } from '../../../constants';
import { AIDisclaimerAndFeedback } from '../../common/ui/ai-disclaimer-and-feedback';
import { AITabs } from '../../common/ui/ai-tabs';
import { AITabsHeader, AITabsHeaderWithSourcesStack } from '../../common/ui/ai-tabs-header';
import { AITabsPanel } from '../../common/ui/ai-tabs-panel';
import { AITabsSources } from '../../common/ui/ai-tabs-sources';
import LocationDark from '../assets/location-dark.svg';
import LocationLight from '../assets/location-light.svg';
import { StandardActionsKnowledgeCard } from '../standard-cards/StandardActionsKnowledgeCard';
var messages = defineMessages({
  knowledge_card_location_category: {
    id: 'search_ai_knowledge_card_location_category',
    defaultMessage: 'Location',
    description: 'Category header for location knowledge card'
  },
  knowledge_card_location_google_maps_action: {
    id: 'search_ai_knowledge_card_location_google_maps_action',
    defaultMessage: 'Show on Google Maps',
    description: 'Button to show in Google'
  }
});
var styles = {
  fullHeight: "_4t3i1osq",
  containerStyles: "_ca0qze3t _u5f3ze3t _19bvze3t _n3tdze3t",
  disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66"
};
var generateGoogleMapsLink = function generateGoogleMapsLink(location) {
  var encodedAddress = encodeURIComponent(location);
  return "https://www.google.com/maps/search/?api=1&query=".concat(encodedAddress);
};
export var LocationCard = function LocationCard(_ref) {
  var location = _ref.location;
  var _useState = useState(AIAnswerTab.AI_ANSWER),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAIAnswerContext = useAIAnswerContext(),
    brand = _useAIAnswerContext.brand,
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var answerString = commonAttributes.answerString,
    query = commonAttributes.query,
    queryHash = commonAttributes.queryHash,
    searchSessionId = commonAttributes.searchSessionId,
    sources = commonAttributes.sources;
  var _getSAINLayerFrontend = getSAINLayerFrontendMutiArmExperiment({
      abTestId: 'kd_sain_sources_redesign_pt_2'
    }),
    cohortSourcesRedesignExperimentPt2 = _getSAINLayerFrontend.cohort;
  var handleTabChange = useCallback(function (selectedTabIndex) {
    var selectedTab = aiAnswerTabsOrder[selectedTabIndex];
    setSelectedTab(selectedTab);
    fireAnalyticsEvent(onAIAnswerTabClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      selectedTab: selectedTab
    })));
  }, [setSelectedTab, fireAnalyticsEvent, commonAttributes]);
  var copyLocation = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(location) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fireSAINUsageEvent({
              metCriteria: SainAction.COPY_CLICKED,
              commonAttributes: commonAttributes
            });
            fireAnalyticsEvent(onAIAnswerCopyButtonClicked(commonAttributes));
            _context.next = 4;
            return navigator.clipboard.writeText(location);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function copyLocation(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClickGoogleMaps = useCallback(function () {
    fireAnalyticsEvent(onNonGenerativeAIAnswerResultShown({
      answerString: answerString,
      brand: brand,
      query: query,
      queryHash: queryHash,
      searchSessionId: searchSessionId,
      source: 'location_knowledge_card',
      answerCardType: AnswerCardType.LOCATION
    }));
    fireSAINUsageEvent({
      metCriteria: SainAction.SHOW_ON_GOOGLE_MAPS_CLICKED
    });
  }, [answerString, brand, fireAnalyticsEvent, fireSAINUsageEvent, query, queryHash, searchSessionId]);
  var googleMapsLink = generateGoogleMapsLink(location);
  return /*#__PURE__*/React.createElement(Stack, {
    alignBlock: "stretch",
    grow: "fill",
    spread: "space-between",
    xcss: styles.fullHeight
  }, /*#__PURE__*/React.createElement(AITabs, {
    onChange: handleTabChange,
    selectedTabIndex: aiAnswerTabsOrder.indexOf(selectedTab)
  }, cohortSourcesRedesignExperimentPt2 === 'sources_tab_redesign' ? /*#__PURE__*/React.createElement(AITabsHeaderWithSourcesStack, {
    sources: sources
  }) : /*#__PURE__*/React.createElement(AITabsHeader, {
    showSourcesTab: sources.length > 0
  }), /*#__PURE__*/React.createElement(AITabsPanel, null, /*#__PURE__*/React.createElement(StandardActionsKnowledgeCard, {
    name: "smart-answer-location-knowledge-card",
    category: formatMessage(messages.knowledge_card_location_category),
    primaryDescription: location,
    actions: [/*#__PURE__*/React.createElement(LinkButton, {
      href: googleMapsLink,
      onClick: onClickGoogleMaps
    }, formatMessage(messages.knowledge_card_location_google_maps_action)), /*#__PURE__*/React.createElement(IconButton, {
      icon: CopyIcon,
      label: "copy",
      onClick: function onClick() {
        return copyLocation(location);
      }
    })],
    media: /*#__PURE__*/React.createElement(Image, {
      src: LocationLight,
      srcDark: LocationDark,
      alt: ''
    }),
    size: "full",
    containerStyles: styles.containerStyles
  })), sources.length > 0 ? /*#__PURE__*/React.createElement(AITabsPanel, null, /*#__PURE__*/React.createElement(AITabsSources, null)) : null), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.disclaimer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: true,
    showCopyButton: true,
    copyText: location
  })));
};